import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	chartTitle: {
		id: 'software-deployment-frequency-report.per-deployment-detail-table.chart-title',
		defaultMessage: 'Deployments',
		description: 'Title of the table that shows each deployment detail',
	},
	jiraIssuePerDeploymentColumnHead: {
		id: 'software-deployment-frequency-report.per-deployment-detail-table.jira-issue-per-deployment-column-head',
		defaultMessage: 'Jira issues per deployments',
		description: 'The table column head for showing the number of issues per deployment',
	},
	deploymentColumnHead: {
		id: 'software-deployment-frequency-report.per-deployment-detail-table.deployment-column-head',
		defaultMessage: 'Deployment',
		description: 'The table column head for showing deployment name',
	},
	environmentNameColumnHead: {
		id: 'software-deployment-frequency-report.per-deployment-detail-table.environment-name-column-head',
		defaultMessage: 'Environment name',
		description:
			'The table column head for showing environment name to which the deployment is deployed',
	},
	pipelineColumnHead: {
		id: 'software-deployment-frequency-report.per-deployment-detail-table.pipeline-column-head',
		defaultMessage: 'Pipeline',
		description: 'The table column head for showing pipeline that made the deployment',
	},
	dateDeployedColumnHead: {
		id: 'software-deployment-frequency-report.per-deployment-detail-table.date-deployed-column-head',
		defaultMessage: 'Date deployed',
		description: 'The table column head for showing the date of the deployment',
	},
	jiraIssuePerDeploymentColumnHeadIssueTermRefresh: {
		id: 'software-deployment-frequency-report.per-deployment-detail-table.jira-issue-per-deployment-column-head-issue-term-refresh',
		defaultMessage: 'Jira work items per deployments',
		description: 'The table column head for showing the number of issues per deployment',
	},
});
